import React from 'react';
import { Form } from 'react-bootstrap';

interface PrimeiroFormularioProps {
    formValues: {
        dmTipoAnuncio: boolean;
        cdAnuncio?: string;
        dtPublicacao: string;
        dmAtivo: boolean;
        [key: string]: any;
    };
    handleFieldChange: (field: string, value: any) => void;
    idPagina?: string;
}

function PrimeiroFormulario({ formValues, handleFieldChange, idPagina }: PrimeiroFormularioProps) {

    const dataAtual = new Date().toLocaleDateString('en-CA');
    const dataAnuncio = new Date(formValues.dtPublicacao).toLocaleDateString('en-CA');
    const paragrafroAguardandoPublicacao = <p className='AguardandoPublicacao' style={{ margin: '0' }}>Aguardando publicação...</p>;

    return (
        <div className='ProdutoServicoAlterar'>
            <div className='radio'>
                <div className="form-check">
                    <input
                        className="form-check-input"
                        type="radio"
                        id="produto"
                        value={formValues.dmTipoAnuncio === true ? 'true' : ''}
                        checked={formValues.dmTipoAnuncio === true}
                        onChange={() => handleFieldChange('dmTipoAnuncio', true)}
                    />
                    <label className={`form-check-label ${formValues.dmTipoAnuncio ? 'produtoSelecionado' : 'dermarcado'} `} htmlFor="produto">
                        Produto
                    </label>
                </div>
                <div className="form-check">
                    <input
                        className="form-check-input"
                        type="radio"
                        id="servico"
                        value={formValues.dmTipoAnuncio === false ? 'false' : ''}
                        checked={formValues.dmTipoAnuncio === false}
                        onChange={() => handleFieldChange('dmTipoAnuncio', false)}
                    />
                    <label className={`form-check-label ${!formValues.dmTipoAnuncio ? 'servicoSelecionado' : 'dermarcado'}`} htmlFor="servico">
                        Serviço
                    </label>
                </div>
            </div>
            <div className='d-flex gap-2 align-items-center'>
                {idPagina && <span style={{ fontFamily: 'Poppins' }}>Status: </span>}
                {((dataAnuncio > dataAtual && !formValues.dmAtivo) || ((formValues.dmAtivo === false) && (dataAnuncio === dataAtual))) ? paragrafroAguardandoPublicacao :
                    formValues.cdAnuncio &&
                    <Form>
                        <Form.Check
                            type="switch"
                            id="custom-switch"
                            label={formValues.dmAtivo ? 'Ativo' : 'Oculto'}
                            checked={formValues.dmAtivo}
                            onChange={(e) => handleFieldChange('dmAtivo', e.target.checked)}
                        />
                    </Form>
                }
            </div>
        </div>
    );
}

export default PrimeiroFormulario;
